
export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录系统'
    },
    component: () => import('./login')
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      title: '注册账号'
    },
    component: () => import('./register')
  }
]
